/* PLP store selection sheet */
'use strict';

import { queryFirst, addClass, removeClass } from '../domUtil';
import { getJSON } from '../util';
import { includeGoogleMaps, getLatLong } from '../googleMaps';
import { handleISPUModalClose, handleDetectLocation } from './pickUpInStore/ispuHelper';
import { HIDDEN_CLASS } from '../constants';

const hiddenClass = 'd-none';
let ispuContainer = queryFirst('.select-a-store-container');
let $ispuModalContainer = $('.lp-slideout-modal[id*="select-a-store-modal"]');
const $spinner = $('#select-a-store-modal .modal-dialog').spinner();
const $ispuClosestParent = $('.search-results.container');

/**
 * This method handles the store results content
 * @param {Object} data store results
 */
function handleStoreResults(data) {
    const noStoresMessage = queryFirst('.store-locator-no-results', ispuContainer);
    const storeResults = queryFirst('.pick-up-in-stores', ispuContainer);
    const findStoreForm = queryFirst('.find-stores-form', ispuContainer);
    addClass(queryFirst('.geo-location-error', ispuContainer), HIDDEN_CLASS);
    if (data.storesResultsHtml) {
        storeResults.innerHTML = data.storesResultsHtml;
        noStoresMessage.textContent = '';
        removeClass(storeResults, HIDDEN_CLASS);
        addClass([noStoresMessage, findStoreForm], HIDDEN_CLASS);
    } else if (data.noStoresErrorMessage) {
        noStoresMessage.innerHTML = data.noStoresErrorMessage;
        addClass(storeResults, HIDDEN_CLASS);
        removeClass(noStoresMessage, HIDDEN_CLASS);
    }
    $spinner.stop();
}

/**
 * This method is an error handler of ajax call
 */
function errorCallBack() {
    $spinner.stop();
}

// Event listener to retrieve store results on click of Pick up in store in PDP
$ispuClosestParent.on('click', '.btn-in-store-pickup', event => {
    const { googleKey } = event.currentTarget.dataset;
    includeGoogleMaps(googleKey);
});

// Event listener to select a store from ISPU drawer
$ispuClosestParent.on('click', '.btn-select-store', event => {
    const { target } = event;
    const { storeId, storeName, storeCity, storeStateCode } = target.dataset;
    $ispuClosestParent.trigger('filter:updateStoreId', { storeId, storeName, storeCity, storeStateCode });

    $(target).closest('.lp-slideout-modal').modal('hide');
});

$ispuClosestParent.on('click', '.search-store-toggle', event => {
    event.preventDefault();
    removeClass(queryFirst('.find-stores-form'), HIDDEN_CLASS);
    addClass(queryFirst('.pick-up-in-stores'), HIDDEN_CLASS);
});

/**
 * This method retrieves store results based on zipcode, city or state
 * @param {Object} locationData google location data based on input value
 */
function handleInStore(locationData) {
    const { latitude, longitude, address, actionUrl, forceGeoLocation } = locationData;
    const data = { latitude, longitude, inputSearchParameter: address, forceGeoLocation, isPLP: true };

    $spinner.start();
    getJSON(actionUrl, 'GET', data, handleStoreResults, errorCallBack);
}

// Event listener to retrieve store results based on input search in pick up in store drawer
$ispuClosestParent.on('submit', '.find-stores-form', event => {
    event.preventDefault();
    const { target } = event;
    const actionUrl = target.getAttribute('action');
    const address = queryFirst('.find-store-input', target.closest('.find-stores-form')).value;
    if (address) {
        getLatLong(handleInStore, { address, actionUrl });
    }
});

// Event listener to toggle store details accordion label
$ispuClosestParent.on('click', '.store-locator-container .store-btn-link', event => {
    const { target } = event;
    queryFirst('.collapsed', target).classList.toggle(hiddenClass);
    queryFirst('.expanded', target).classList.toggle(hiddenClass);
});

// Event listener to remove no stores error message on change of ISPU search input
$ispuClosestParent.on('keyup', '.find-store-input', (event) => {
    queryFirst('.store-locator-no-results', $ispuModalContainer[0]).textContent = '';
    queryFirst('.pick-up-in-stores', ispuContainer).innerHTML = '';
    addClass(queryFirst('.geo-location-error', ispuContainer), hiddenClass);
    const findStoreSubmit = queryFirst('.find-store-submit', ispuContainer);
    if (event.target.value) {
        findStoreSubmit.removeAttribute('disabled');
    } else {
        findStoreSubmit.disabled = true;
    }
});

const LP_STORE_MODAL_TRIGGER_KEY = 'lpSelectStoreModalTrigger';

$ispuModalContainer.on('show.bs.modal', (e) => {
    const $modal = $(e.target);
    const related = e.relatedTarget || e?.originalEvent?.relatedTarget;
    let trigger = null;
    if (related && typeof related.closest === 'function') {
        trigger = related.closest('.btn-in-store-pickup[data-target="#select-a-store-modal"]');
    }
    if (trigger) {
        includeGoogleMaps(trigger.dataset.googleKey);
    }
    $modal.data(LP_STORE_MODAL_TRIGGER_KEY, trigger || null);
});

$ispuModalContainer.on('hide.bs.modal', function () {
    const $modal = $(this);
    const trigger = $modal.data(LP_STORE_MODAL_TRIGGER_KEY);
    if (trigger) {
        // modal.js sets data('opener', lastInteractedEl) on shown; restore the real trigger before
        // hidden.bs.modal so focus return targets a focusable opener (not a chevron/icon child).
        $modal.data('opener', trigger);
    }
});

$ispuModalContainer.on('hidden.bs.modal', function () {
    $(this).removeData(LP_STORE_MODAL_TRIGGER_KEY);
    handleISPUModalClose(ispuContainer);
});

// Event listener to retrieve geo location based store results on click of use current location
$ispuClosestParent.on('click', '.detect-location', (event) => handleDetectLocation(event, ispuContainer, handleInStore));
